export default {
	NO_DATA: 'No report to show',
};
